 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"1":"product-option-chain-position-selectable~product-option-color-inline~product-option-color-selectable~ec876204","2":"splidejs-splide","3":"tom-select","5":"adyen-adyen-web","6":"pinch-zoom-js","34":"cart-modify-option-color","35":"cart-modify-option-custom-image","36":"cart-modify-option-custom-text","37":"cart-modify-option-glass-reversed","38":"cart-modify-option-material-canvas","39":"cart-modify-option-material-color","40":"cart-modify-option-model","41":"cart-modify-option-model-size","42":"cart-modify-option-pack","43":"cart-modify-option-size","44":"cart-modify-option-support-color","45":"cart-modify-option-tissue","46":"cart-modify-option-tissue-drop","48":"header-cart-general","49":"header-cart-item-general","50":"header-cart-item-image-zoom","51":"header-cart-voucher","52":"header-left-menu-v2","146":"popup-image-zoom","147":"popup-personalized-text","148":"product-option-chain-position-selectable","149":"product-option-color-inline","150":"product-option-color-selectable","151":"product-option-custom-image-inline","152":"product-option-custom-image-selectable","153":"product-option-custom-text-inline","154":"product-option-custom-text-selectable","155":"product-option-frame-inline","156":"product-option-glass-reversed-inline","157":"product-option-material-color-inline","158":"product-option-model-inline","159":"product-option-model-size-inline","160":"product-option-motorbike-kit-selectable","161":"product-option-orientation-inline","162":"product-option-pack-inline","163":"product-option-pack-selectable","164":"product-option-size-inline-selectable","165":"product-option-size-multiple-selectable","166":"product-option-size-selectable","167":"product-option-size-single-value","168":"product-option-size-wallpaper","169":"product-option-support-color-selectable","170":"product-option-tissue-drop-selectable","171":"product-option-tissue-selectable","172":"product-option-vinyl-rug-format-inline","173":"product-page-ar-tool","174":"product-page-reviews","175":"product-page-v2-reviews","176":"product-tool-wallpaper-calculator","177":"vendors~product-option-material-color-inline","178":"vertex-filters-post-render-dynamic","179":"vertex-general-combination-suggestions-dynamic"}[chunkId]||chunkId) + ".20261014_" + {"1":"4b88941946a9567ef858","2":"312b886bb8214fc56682","3":"a5223f6a85c05d65c824","4":"01a03e458c08e3bd3bf5","5":"955f4fd95bd6f248bfa1","6":"8fd7fad5b74011aa9eaf","7":"00d1b13d32b3bc24abc3","8":"2b6aaa5ead7d4cbdc954","9":"17ef99fe699cc3bff3f7","10":"e99aceca25f00d5f0974","11":"758fa1e8e489fe94ce04","12":"78229498117b2f81dffa","13":"5f0d57833bd18cb7fd2e","14":"4b2bfb5d22f2a901a46a","15":"420a56c6fbe6cfd52516","16":"a6de5f10de6f33cf8562","17":"baddcbe813bde4a2dfe1","18":"3d189f8241817421dbfc","19":"eb8870af50f7ad38f475","20":"f2af3621b3a28620f87e","21":"f893900beba80695e887","22":"f1f1dfe960ee48548e9f","23":"2949fe036ff635a3bda9","24":"87e33804c4b7ef8522d6","25":"f6bc6fe16ed25b10f75d","26":"54fb14b58cf723256cb5","27":"f6671a61618331fd2d58","28":"2a25ffe57e9424a074b5","29":"f2c5e451a24220b17a37","30":"d15b94f87d55d5d328bf","31":"cdbeb989dd4ed162b50c","32":"91f585a2fd1f569d6696","34":"726cd6b28727b3ffa5bf","35":"d3e6e0fa5318491dd769","36":"30be9becb5e171b05235","37":"9b2629412bff4ff90c69","38":"60f4672934d8a90dbe65","39":"267f209780c3ea1ccfd5","40":"0f5f4f5200ac61b18857","41":"5cdd50ddba33c2ccf908","42":"9a18dbcb58aded10801d","43":"a62cdd6b179429b26a7c","44":"83861926c5bb5c0f0b3b","45":"72e07800187104e988ce","46":"af0c786d7b735785c582","48":"db1c8c8b95d65cb76b1f","49":"a270439583f60312196b","50":"2838e2cb7450d62c35d1","51":"b9a1929b034ad96f2c2b","52":"4ec79c389241f83a6c97","146":"fca5e838a318edd30653","147":"b3f22ebef062bded8b7a","148":"18d6f11b0ecc0e80426b","149":"a7cca635d6838611e945","150":"61f1d313bb868da8b088","151":"28f620abfb66719d7590","152":"725cd9f71fe7925ce3ce","153":"cfbb2dbf0c4a9658358d","154":"36dd2093d9f297795c59","155":"234a26d78337902658b3","156":"61bea69fa0f467e82e81","157":"98f2638a104817594f53","158":"1b2b518b307aafe8343f","159":"7ae47070cb1386ef2ac6","160":"7e3c2b6d83e4d3b23cbd","161":"baf9674b1ad27a83ab5a","162":"9b166f5082cafee8333a","163":"1b238fb3f22cbb51188b","164":"d1afed96f53a35230bfc","165":"06d3b6fe5cb370d8fa34","166":"4dc403783776ec609a15","167":"2b39acf7e8091d218fae","168":"433039932e8c06a860d7","169":"3230e15df4dcae034a66","170":"6deb21754ea84cacb465","171":"911bc6e7cb7b2e3786e0","172":"ae5d3b8c06f43df0f122","173":"be8cbbdeb92a4629035d","174":"6aabd43b6cf20025e8e1","175":"8949a731317c45a1be8e","176":"89fb0429cb877e6d5756","177":"8d094a7fdbaf5e5c9e82","178":"5abf62684ebd105dfef6","179":"4a4d7d9a761cf12b288b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"177":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"1":"product-option-chain-position-selectable~product-option-color-inline~product-option-color-selectable~ec876204","2":"splidejs-splide","3":"tom-select","5":"adyen-adyen-web","6":"pinch-zoom-js","34":"cart-modify-option-color","35":"cart-modify-option-custom-image","36":"cart-modify-option-custom-text","37":"cart-modify-option-glass-reversed","38":"cart-modify-option-material-canvas","39":"cart-modify-option-material-color","40":"cart-modify-option-model","41":"cart-modify-option-model-size","42":"cart-modify-option-pack","43":"cart-modify-option-size","44":"cart-modify-option-support-color","45":"cart-modify-option-tissue","46":"cart-modify-option-tissue-drop","48":"header-cart-general","49":"header-cart-item-general","50":"header-cart-item-image-zoom","51":"header-cart-voucher","52":"header-left-menu-v2","146":"popup-image-zoom","147":"popup-personalized-text","148":"product-option-chain-position-selectable","149":"product-option-color-inline","150":"product-option-color-selectable","151":"product-option-custom-image-inline","152":"product-option-custom-image-selectable","153":"product-option-custom-text-inline","154":"product-option-custom-text-selectable","155":"product-option-frame-inline","156":"product-option-glass-reversed-inline","157":"product-option-material-color-inline","158":"product-option-model-inline","159":"product-option-model-size-inline","160":"product-option-motorbike-kit-selectable","161":"product-option-orientation-inline","162":"product-option-pack-inline","163":"product-option-pack-selectable","164":"product-option-size-inline-selectable","165":"product-option-size-multiple-selectable","166":"product-option-size-selectable","167":"product-option-size-single-value","168":"product-option-size-wallpaper","169":"product-option-support-color-selectable","170":"product-option-tissue-drop-selectable","171":"product-option-tissue-selectable","172":"product-option-vinyl-rug-format-inline","173":"product-page-ar-tool","174":"product-page-reviews","175":"product-page-v2-reviews","176":"product-tool-wallpaper-calculator","177":"vendors~product-option-material-color-inline","178":"vertex-filters-post-render-dynamic","179":"vertex-general-combination-suggestions-dynamic"}[chunkId]||chunkId) + ".20261014_" + {"1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","146":"31d6cfe0d16ae931b73c","147":"31d6cfe0d16ae931b73c","148":"31d6cfe0d16ae931b73c","149":"31d6cfe0d16ae931b73c","150":"31d6cfe0d16ae931b73c","151":"31d6cfe0d16ae931b73c","152":"31d6cfe0d16ae931b73c","153":"31d6cfe0d16ae931b73c","154":"31d6cfe0d16ae931b73c","155":"31d6cfe0d16ae931b73c","156":"31d6cfe0d16ae931b73c","157":"31d6cfe0d16ae931b73c","158":"31d6cfe0d16ae931b73c","159":"31d6cfe0d16ae931b73c","160":"31d6cfe0d16ae931b73c","161":"31d6cfe0d16ae931b73c","162":"31d6cfe0d16ae931b73c","163":"31d6cfe0d16ae931b73c","164":"31d6cfe0d16ae931b73c","165":"31d6cfe0d16ae931b73c","166":"31d6cfe0d16ae931b73c","167":"31d6cfe0d16ae931b73c","168":"31d6cfe0d16ae931b73c","169":"31d6cfe0d16ae931b73c","170":"31d6cfe0d16ae931b73c","171":"31d6cfe0d16ae931b73c","172":"31d6cfe0d16ae931b73c","173":"31d6cfe0d16ae931b73c","174":"31d6cfe0d16ae931b73c","175":"31d6cfe0d16ae931b73c","176":"31d6cfe0d16ae931b73c","177":"f0f552e634aed8edb2e2","178":"31d6cfe0d16ae931b73c","179":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
